// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  LobbyVision2AddressingConfig,
  LobbyVision2AddressingConfigT,
  verifyLobbyVision2AddressingConfig,
} from "./lobby-vision2-addressing-config";
import {
  LobbyVision2ReadEntry,
  LobbyVision2ReadEntryT,
  verifyLobbyVision2ReadEntry,
} from "./lobby-vision2-read-entry";
import {
  LobbyVision2WriteEntry,
  LobbyVision2WriteEntryT,
  verifyLobbyVision2WriteEntry,
} from "./lobby-vision2-write-entry";

/**
 * Complete `LobbyVision2` `CDO` template stored in `cdo_binary` for LV2 adapters.
 * Expands to a `LobbyVision2.Mapping` at `CDO` generation time.
 */
export class LobbyVision2Template implements flatbuffers.IUnpackableObject<LobbyVision2TemplateT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): LobbyVision2Template {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsLobbyVision2Template(
    bb: flatbuffers.ByteBuffer,
    obj?: LobbyVision2Template,
  ): LobbyVision2Template {
    return (obj || new LobbyVision2Template()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsLobbyVision2Template(
    bb: flatbuffers.ByteBuffer,
    obj?: LobbyVision2Template,
  ): LobbyVision2Template {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new LobbyVision2Template()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  reads(index: number, obj?: LobbyVision2ReadEntry): LobbyVision2ReadEntry | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new LobbyVision2ReadEntry()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  readsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  writes(index: number, obj?: LobbyVision2WriteEntry): LobbyVision2WriteEntry | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new LobbyVision2WriteEntry()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  writesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Per-adapter addressing scheme. OPTIONAL — null means "use all defaults"
   * (`IndexBased`, base 1, bank sentinel 0, floor `data` = `floor_index`).
   * Appended last for wire back-compat, mirroring `ModbusTemplate.register_offsets`.
   */
  addressing(obj?: LobbyVision2AddressingConfig): LobbyVision2AddressingConfig | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new LobbyVision2AddressingConfig()).__init(
          this.bb!.__indirect(this.bb_pos + offset),
          this.bb!,
        )
      : null;
  }

  static startLobbyVision2Template(builder: flatbuffers.Builder) {
    builder.startObject(3);
  }

  static addReads(builder: flatbuffers.Builder, readsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, readsOffset, 0);
  }

  static createReadsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startReadsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addWrites(builder: flatbuffers.Builder, writesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, writesOffset, 0);
  }

  static createWritesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startWritesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addAddressing(builder: flatbuffers.Builder, addressingOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, addressingOffset, 0);
  }

  static endLobbyVision2Template(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static finishLobbyVision2TemplateBuffer(
    builder: flatbuffers.Builder,
    offset: flatbuffers.Offset,
  ) {
    builder.finish(offset);
  }

  static finishSizePrefixedLobbyVision2TemplateBuffer(
    builder: flatbuffers.Builder,
    offset: flatbuffers.Offset,
  ) {
    builder.finish(offset, undefined, true);
  }

  unpack(): LobbyVision2TemplateT {
    return new LobbyVision2TemplateT(
      this.bb!.createObjList<LobbyVision2ReadEntry, LobbyVision2ReadEntryT>(
        this.reads.bind(this),
        this.readsLength(),
      ),
      this.bb!.createObjList<LobbyVision2WriteEntry, LobbyVision2WriteEntryT>(
        this.writes.bind(this),
        this.writesLength(),
      ),
      this.addressing() !== null ? this.addressing()!.unpack() : null,
    );
  }

  unpackTo(_o: LobbyVision2TemplateT): void {
    _o.reads = this.bb!.createObjList<LobbyVision2ReadEntry, LobbyVision2ReadEntryT>(
      this.reads.bind(this),
      this.readsLength(),
    );
    _o.writes = this.bb!.createObjList<LobbyVision2WriteEntry, LobbyVision2WriteEntryT>(
      this.writes.bind(this),
      this.writesLength(),
    );
    _o.addressing = this.addressing() !== null ? this.addressing()!.unpack() : null;
  }

  unpackFields(...fields: string[]): LobbyVision2TemplateT {
    const t = new LobbyVision2TemplateT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("reads")) {
      t.reads = this.bb!.createObjList<LobbyVision2ReadEntry, LobbyVision2ReadEntryT>(
        this.reads.bind(this),
        this.readsLength(),
      );
    }
    if (fieldSet.has("writes")) {
      t.writes = this.bb!.createObjList<LobbyVision2WriteEntry, LobbyVision2WriteEntryT>(
        this.writes.bind(this),
        this.writesLength(),
      );
    }
    if (fieldSet.has("addressing")) {
      t.addressing = this.addressing() !== null ? this.addressing()!.unpack() : null;
    }
    return t;
  }
}

export class LobbyVision2TemplateT implements flatbuffers.IGeneratedObject {
  constructor(
    public reads: LobbyVision2ReadEntryT[] = [],
    public writes: LobbyVision2WriteEntryT[] = [],
    public addressing: LobbyVision2AddressingConfigT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const reads = LobbyVision2Template.createReadsVector(
      builder,
      builder.createObjectOffsetList(this.reads),
    );
    const writes = LobbyVision2Template.createWritesVector(
      builder,
      builder.createObjectOffsetList(this.writes),
    );
    const addressing = this.addressing !== null ? this.addressing!.pack(builder) : 0;

    LobbyVision2Template.startLobbyVision2Template(builder);
    LobbyVision2Template.addReads(builder, reads);
    LobbyVision2Template.addWrites(builder, writes);
    LobbyVision2Template.addAddressing(builder, addressing);

    return LobbyVision2Template.endLobbyVision2Template(builder);
  }

  clone(): LobbyVision2TemplateT {
    const obj = new LobbyVision2TemplateT();
    obj.reads = this.reads.map((e) => e.clone());
    obj.writes = this.writes.map((e) => e.clone());
    obj.addressing = this.addressing !== null ? this.addressing!.clone() : null;
    return obj;
  }

  equals(other: LobbyVision2TemplateT): boolean {
    if (this.reads.length !== other.reads.length) return false;
    for (let i = 0; i < this.reads.length; i++) {
      const a = this.reads[i];
      const b = other.reads[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.writes.length !== other.writes.length) return false;
    for (let i = 0; i < this.writes.length; i++) {
      const a = this.writes[i];
      const b = other.writes[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.addressing !== null && other.addressing !== null) {
      if (!this.addressing!.equals(other.addressing!)) return false;
    } else if (this.addressing !== other.addressing) return false;
    return true;
  }
}

export function verifyLobbyVision2Template(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyLobbyVision2ReadEntry);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyLobbyVision2WriteEntry);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyLobbyVision2AddressingConfig(verifier, fieldPos + tableOffset);
      }
    }
  } finally {
    verifier.popDepth();
  }
}

export function verifyRootAsLobbyVision2Template(
  buf: DataView,
  opts?: flatbuffers.VerifierOptions,
): void {
  const verifier = new flatbuffers.Verifier(buf, opts);
  const tablePos = verifier.readUint32(0);
  verifyLobbyVision2Template(verifier, tablePos);
}
